import React from 'react'
import styled from 'styled-components'

export const StyledComponent = styled(({...rest}) => <header {...rest} />)`
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.cWhite};

`

const _PageHeader_Loader_Wrapper = (props) => <StyledComponent {...props} />
_PageHeader_Loader_Wrapper.propTypes = {}
_PageHeader_Loader_Wrapper.className = StyledComponent

export default _PageHeader_Loader_Wrapper

